export default __webpack_public_path__ + "static/media/course_img_i.9d25ba05.jpg";